import React from 'react';
import type { TalentSearchItem } from '@axiom/validation';
import { DataTest, Gutter, Checkbox } from '@axiom/ui';

export interface TalentSearchFiltersTemplateProps {
  area: 'alwaysShow' | 'showHide';
  disabled: boolean;
  groupingName?: string;
  index: number;
  item: TalentSearchItem;
  parentIndex: number;
}

export const TalentSearchFiltersTemplate = ({
  item,
  index,
  parentIndex,
  disabled,
  area,
  groupingName,
}: TalentSearchFiltersTemplateProps) => {
  const name = `categories.${parentIndex}.items${
    groupingName ? `.${groupingName}` : ''
  }.${area}.${index}.checked`;
  return (
    <Gutter bottom="8px">
      <DataTest value="CHECKBOX_CONTAINER">
        <DataTest value={JSON.stringify(item.id)}>
          <Checkbox name={name} displayValue={item.name} disabled={disabled} />
        </DataTest>
      </DataTest>
    </Gutter>
  );
};
